/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*
*/

import { Component, inject } from '@angular/core';
import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { ChosenWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { AvailableWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { DialogBannerComponent } from '@src/app/shared/dialogs/dialog-banner-component';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { EditWidgetDialogComponent } from '@src/app/shared/dashboard/edit-widget/edit-widget.component';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { DashboardChartComponent } from '@src/app/shared/dashboard/dashboard-widget/dashboard-widget.component';
import { MatTooltip } from "@angular/material/tooltip";


@Component({
    selector: 'app-configure-dashboard',
    imports: [DragDropModule, DialogBannerComponent, FormsModule, MatIconModule, MatButtonModule, MatDialogModule, DashboardChartComponent, MatTooltip],
    templateUrl: './configure-dashboard.component.html',
    styleUrl: './configure-dashboard.component.scss'
})
export class ConfigureDashboardComponent {
  dialogRef = inject(MatDialogRef<EditWidgetDialogComponent>);
  cds = inject(ConfirmDialogService);
  allWidgets: AvailableWidget[] = [];
  chosenWidgets: ChosenWidget[] = [];
  previewWidget: ChosenWidget;
  availableForPreview: AvailableWidget[];
  public inputs = inject(MAT_DIALOG_DATA) as {
    allWidgets: AvailableWidget[];
    chosenWidgets: ChosenWidget[];
    defaultWidgets: ChosenWidget[]
    reDrawCharts: () => void;
  };
  dialog = inject(MatDialog);

  constructor() {
    console.log(this.inputs);
    this.chosenWidgets = this.inputs.chosenWidgets;
    this.refreshAvailable();
  }

  refreshAvailable() {
    this.allWidgets = this.inputs.allWidgets.filter( w => !this.chosenWidgets.find( cw => cw.code === w.code));    
  }

  selectForPreview(w: AvailableWidget|ChosenWidget) {
    const pwo = this.inputs.allWidgets.find( aw => aw.code === w.code);
    if (!pwo) {
        console.error('widget not found', w);
    }
    const pwo2 = {... pwo};    
    if (!pwo.widgetClass) {

      pwo2.chart = pwo2.maker()
    }
    this.availableForPreview = [pwo2];

    this.previewWidget = {code: w.code, widthWeight: 2, heightWeight: 2}
    if (!pwo.widgetClass) {
      setTimeout(() => pwo2.chart.reSize());
    }
    
  }

  drop(event: CdkDragDrop<Element[]>, targetList: 'chosen' | 'available') {
    console.log({event, targetList});
    if (targetList === 'chosen') {
      if (event.previousContainer === event.container) {
        moveItemInArray(this.chosenWidgets, event.previousIndex, event.currentIndex);
        this.updateCharts();
      } else {
        const chartToShow = this.allWidgets[event.previousIndex];
        //chartParms: chartToShow.chartParms, 
        this.chosenWidgets.splice(event.currentIndex, 0, 
          { code: chartToShow.code, widthWeight: 2, heightWeight: 2 }
        );
        this.refreshAvailable();
        this.updateCharts();
      }
    } else {
      if (event.previousContainer === event.container) {
        // Nothing to do, we do not sort the available
      } else {
        this.chosenWidgets.splice(event.previousIndex,1);
        this.refreshAvailable();
      }

    }
  }

  resetToDefault() {
    const title = $localize `Reset to default charts`;
    const msg = $localize `Do you want to forget your configured dashboard and use the default dashboard instead?`
    this.cds.open(title, msg, () => {
        this.chosenWidgets.length = 0;
        this.inputs.defaultWidgets.forEach( dw => this.chosenWidgets.push(dw));
        this.updateCharts();
        this.dialogRef.close();
    })
  }
  updateCharts() {
    setTimeout( () => this.inputs.reDrawCharts());
  }
  getName(cw: ChosenWidget) {
    const w = this.inputs.allWidgets.find(aw => aw.code === cw.code);
    if (w) {
      return w.name;
    }
    return 'Unknown Widget';
  }
}
